export default {
	name: "indexView",
	data() {
		return {
			partnerList: []
		};
	},
	watch: {},
	async mounted() {
		await this.getPartnerList();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getPartnerList() {
			const listRes = await this.$zkHttp.user$getMyTeam({
				user_id: this.$store.state.auth.user_id,
			});
			console.log("listRes ===> ", listRes);
			this.partnerList = listRes;
		},
		load(row, treeNode, resolve) {
			console.log("load ===> ", row);
			setTimeout(() => {
				resolve(row.children)
			}, 1000)
		},
		filterTag(value, row) {
			return row.tag === value;
		},
		toMyPage(page) {
			this.$router.push(`/${page}`);
		},
	},
};